import React from 'react';

// Links out to a video's creator (channel, original upload). Unlike other
// external links these keep the Referer — origin only — so the creators'
// own analytics show the traffic the site sends them.
function CreatorLink({ href, className, children }) {
    return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
            className={className}
            href={href}
            target="_blank"
            rel="noopener"
            referrerPolicy="strict-origin-when-cross-origin"
        >
            {children}
        </a>
    );
}

export default CreatorLink;
